import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ElementRef, Input, Pipe, PipeTransform, AfterViewInit, EventEmitter, Output } from '@angular/core';
import { UntypedFormBuilder, Validators, ControlContainer, FormGroupDirective, UntypedFormControl, FormGroup, FormControl, ValidationErrors } from '@angular/forms';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { GlobalsService } from '../../services/globals.service';
import { OrdersService } from '../../services/orders.service';
import { CardLists, Card } from '../../classes/orders';
import { Router, ActivatedRoute } from '@angular/router';
import { Ng2CompleterModule } from 'ng2-completer';
import { Location } from '@angular/common'
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

import { PrintService } from '../../services/print.service';
import { take } from 'rxjs/operators';

@Component({
	selector: 'app-order-inquiry',
	templateUrl: './order-inquiry.component.html',
	styleUrls: ['./order-inquiry.component.scss']
})

export class OrderInquiryComponent implements OnInit, AfterViewInit {
	@Input() name: string;
	@ViewChild('orderView') orderStatusViewRef: ElementRef;
	@ViewChild('invoiceDetails') invoiceDetailsRef: ElementRef;
	@ViewChild('orderDetails') orderDetailsRef: ElementRef;

	@ViewChild('resultTable') resultTable: ElementRef;

	itemSearchRef = new FormControl('');
	orderSearchRef = new FormControl('');
	orderSearchTypeRef = new FormControl('B');
	filterresults: any = [];
	filteredItems: any = [];
	orderData: CardLists;
	customerData: any = [];
	openOrderData: any = [];
	orders: any = [];
	orderSearch: any = [];
	orderResults: any = false;
	ordersFound: any = [];
	showOrderDetails = false;
	showInvoiceDetails = false;
	color: any = 'blue';
	config: any = [];
	pickinglink: any = '';
	invoicelink: any = '';
	invoicelink2: any = '';
	orderdetails: any = false;
	user: any = false;
	sending = false;
	uncancelPendingOrderNo: string | null = null;
	searchsub: any = false;
	displaydetails: any = false;
	creditlink: any = '';
	creditpickinglink: any = '';
	trackOrder = (_: number, item: any) => item?.orderno ?? _;
	customerNumberRef = new FormControl('');
	// Default to today - 30 days

	startDateRef = new FormControl < Date | null > (new Date(Date.now() - 30 * 24 * 60 * 60 * 1000));
	endDateRef = new FormControl < Date | null > (new Date());



	constructor(private printService: PrintService, private globalsService: GlobalsService, private globalSearchService: GlobalSearchService, public router: Router, private route: ActivatedRoute, private ordersService: OrdersService, private location: Location, private modalService: NgbModal) {

		this.color = this.globalSearchService.getColor();
		this.globalSearchService.configsubscription.subscribe(r => {
			this.config = r;
		});
		this.globalSearchService.mesagesallowed.next(false);

		this.globalSearchService.configsubscription.subscribe(r => {
			this.config = r;
			this.globalSearchService.user.subscribe(u => {
				this.user = u
			})
		});


		this.pickinglink = this.config.apiServer.baseUrl + this.config.apiServer.pickingLink;
		this.invoicelink = this.config.apiServer.baseUrl + this.config.apiServer.pickingInvoice;
		this.invoicelink2 = this.config.apiServer.baseUrl + this.config.apiServer.invoiceLink;

		this.creditlink = this.config.apiServer.baseUrl + this.config.apiServer.creditLink;
		this.creditpickinglink = this.config.apiServer.baseUrl + this.config.apiServer.creditPickingLink;
	}

	ngOnInit(): void {}

	ngAfterViewInit(): void {
		this.route.queryParams.pipe(take(1)).subscribe(params => {
			const orderno = params['orderno'];
			if (orderno && this.orderDetailsRef) {
				this.ordersService.getOrder(orderno).subscribe(order => {
					this.orderdetails = order;
					this.showOrderDetails = true;
					this.showModal(this.orderDetailsRef, 'orderDetails', order);
					this.router.navigate([], { relativeTo: this.route, queryParams: {}, queryParamsHandling: '' });
				});
			}
		});
	}

	viewCustomer(debtorno: string) {
		this.router.navigate(['/customers/view/' + debtorno]);
	}

	viewInvoice(orderno: any) {
		this.ordersService.getInvoicedOrder(orderno).subscribe((order: any) => {
			this.orderdetails = order
			this.modalService.open(this.orderStatusViewRef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {}, (reason) => {});
		});
	}

	viewOrder(orderno: any) {
		this.showOrderDetails = true;
		this.ordersService.getOrder(orderno).subscribe(order => {
			this.orderdetails = order;
			this.showModal(this.orderDetailsRef, 'orderDetails', order);
		});
	}

	openDocument(transaction: any, display: string) {
		this.showInvoiceDetails = true;
		const fetchDetails = transaction.type === '11' ? this.globalsService.getCreditNote(transaction.id, display) : this.globalsService.getInvoice(transaction.id, display);
		fetchDetails.subscribe(result => {
			this.showModal(this.invoiceDetailsRef, 'invoiceDetails', result);
		});
	}

	showModal(ref: ElementRef, modalType: string, data: any) {
		if (modalType === 'orderDetails') {
			this.orderdetails = data;
		} else if (modalType === 'invoiceDetails') {
			this.displaydetails = data;
		}
		this.modalService.open(ref, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then(() => {
			this.resetModalState(modalType);
		}, () => {
			this.resetModalState(modalType);
		});
	}


	clearForm() {

		//	this.customersearch.setValue('')
	}
	resetModalState(modalType: string) {
		if (modalType === 'orderDetails') {
			this.showOrderDetails = false;
			this.orderdetails = null;
		} else if (modalType === 'invoiceDetails') {
			this.showInvoiceDetails = false;
			this.displaydetails = null;
		}
	}

	canUncancelFromInquiry(o: any): boolean {
		if (!o || o.type === 'credit') {
			return false;
		}
		return this.safeInt(o.orderstatusid) === 90;
	}

	uncancelOrderFromInquiry(o: any): void {
		if (!this.canUncancelFromInquiry(o)) {
			return;
		}
		const orderno = String(o.orderno ?? '').trim();
		if (!orderno) {
			return;
		}
		if (!confirm(`Restore cancelled order ${orderno} to Pending?`)) {
			return;
		}
		this.uncancelPendingOrderNo = orderno;
		this.ordersService.uncancelOrder(orderno).subscribe({
			next: (res: any) => {
				this.uncancelPendingOrderNo = null;
				if (res && res.success) {
					this.globalSearchService.showNotification(`Order ${orderno} was restored to open status.`, 'success', 'bottom', 'right');
					this.searchOrders();
					return;
				}
				const msg = (res && (res.message || res.error)) ? String(res.message || res.error) : 'Could not restore order.';
				this.globalSearchService.showNotification(msg, 'danger', 'bottom', 'right');
			},
			error: () => {
				this.uncancelPendingOrderNo = null;
				this.globalSearchService.showNotification('Could not restore order.', 'danger', 'bottom', 'right');
			},
		});
	}

	public searchOrders() {
		// simple date -> 'YYYY-MM-DD' (keeps backend happy without extra deps)
		const fmt = (d: Date | null) =>
			d ? new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate())).toISOString().slice(0, 10) : null;

		// guard: invalid range (optional – silently ignore if end < start)
		const start = this.startDateRef.value;
		const end = this.endDateRef.value;
		const hasBadRange = start && end && end < start;

		const payload: any = {
			keywords: this.orderSearchRef.value,
			orderType: this.orderSearchTypeRef.value,
			issalesman: this.user.user.issalesman,
			salesman: this.user.user.salesman,
			customerNumber: (this.customerNumberRef.value || '').toString().trim() || null,
			dateStart: hasBadRange ? null : fmt(start),
			dateEnd: hasBadRange ? null : fmt(end),
		};

		this.sending = true;
		if (this.searchsub) {
			this.searchsub.unsubscribe();
		}

		this.searchsub = this.ordersService.getOrderInqSearch(payload).subscribe(r => {
			this.sending = false;
			this.orderResults = r;
		});
	}

	public onInput(event: any, keys = 'orderno') {

		// this pushes the input value into the service's Observable.

		this.globalSearchService.searchTerm.next(event.target.value);
		const term = event.target.value;
		const allresults = [];
		if (this.openOrderData) {
			this.setFilteredLists(term);
			this.globalSearchService.itemSearch.next(this.ordersFound);
		}
	}

	filterOrders(orders) {

		const allresults = [];

		if (this.openOrderData && this.orderSearch) {
			const openorders = this.filterItem(this.openOrderData, '-', 'ORDER_NUMBER');
			if (openorders) {
				openorders.forEach(function(value) {
					if (orders.includes(value.ORDER_NUMBER)) {

						allresults.push({ content: 'Open Order', details: value, link: '/orders/lookup/' + value.ORDER_NUMBER })
					}
				});


			}
		}

		this.setFiltered(allresults)

	}

	setFilteredLists(term) {

		const allresults = [];
		const ordersFound = [];
		if (this.openOrderData) {
			const openorders = this.filterItem(this.openOrderData, term, 'ADDRESS_1,CUST_NAME,ORDER_NUMBER,CUST_ORDER_NO_,DATE_ORDERED,DATE_WANTED,CUST_NUMBER,ITEM_NUMBER');
			if (openorders) {
				openorders.forEach(function(value) {
					allresults.push({ content: 'Open Order', details: value, link: '/orders/lookup/' + value.ORDER_NUMBER })
					ordersFound.push(value.ORDER_NUMBER)
				});
			}
		}

		this.ordersFound = ordersFound;


		this.setFiltered(allresults)

	}

	getValueByType(values: any, code: any): number {
		// Always return a number for safe | currency usage
		if (values == null) {return 0;}

		const normalizeCode = (x: any) => (x == null ? '' : String(x).trim().toLowerCase());

		// Extract a numeric from various shapes: raw number, string, or {text/value/amount/...}
		const toNumber = (v: any): number => {
			if (typeof v === 'number' && isFinite(v)) {return v;}
			if (typeof v === 'string') {
				// Strip currency symbols and thousands separators; keep digits, minus, and dot
				const cleaned = v.replace(/[^0-9.\-]/g, '');
				const n = parseFloat(cleaned);
				return isFinite(n) ? n : 0;
			}
			if (v && typeof v === 'object') {
				// Common keys we see in your payloads
				const cand = v.text ?? v.value ?? v.amount ?? v.total ?? v.sub_total ?? v.tax;
				return toNumber(cand);
			}
			return 0;
		};

		// Array of { code, text } or similar
		if (Array.isArray(values)) {
			const want = normalizeCode(code);
			const match = values.find((r: any) => normalizeCode(r?.code) === want);
			return match ? toNumber(match) : 0;
		}

		// Object map support: { tax: '12.34', total: 123.45, ... } or { tax: {text:'$12.34'} }
		if (typeof values === 'object') {
			const direct = (values as any)[code];
			return direct != null ? toNumber(direct) : 0;
		}

		// Fallback
		return 0;
	}



	safeDate(val: any): string | null {
		// guard MySQL zero dates and empty values
		if (!val || val === '0000-00-00' || val === '0000-00-00 00:00:00') {return null;}
		return val;
	}

	safeNum(v: any): number {
		const n = typeof v === 'number' ? v : parseFloat((v ?? '').toString().replace(/[^0-9.\-]/g, ''));
		return isFinite(n) ? n : 0;
	}

	safeInt(v: any): number {
		const n = typeof v === 'number' ? v : parseInt((v ?? '').toString(), 10);
		return isFinite(n) ? n : 0;
	}

	/**
	 * Handle dispatch being {} or [] (sometimes empty array).
	 * Returns the requested field or null.
	 */
	dispatchField(dispatch: any, field: string): any | null {
		if (!dispatch) {return null;}
		if (Array.isArray(dispatch)) {
			return dispatch.length ? (dispatch[0]?.[field] ?? null) : null;
			// If you eventually return multiple dispatch rows, adjust this logic.
		}
		if (typeof dispatch === 'object') {
			return dispatch[field] ?? null;
		}
		return null;
	}

	getFiltered() {
		return this.filteredItems;
	}

	setFiltered(results) {
		this.filteredItems = results;
	}

	assignCopy(input) {
		this.filteredItems = Object.assign([], input);
	}

	filterItem(input, term, keys) {
		if (!term) {
			this.assignCopy(input);
		}
		const result = Object.assign([], input).filter((item) => keys.split(',').some(key => item.hasOwnProperty(key) && new RegExp(term, 'gi').test(item[key])));
		return result
	}

	getDiscountTotal(item: any) {
		const discounted = this.financial(parseFloat(item.unitprice) * (parseFloat(item.discountpercent) / 100));
		const discountprice = parseFloat(item.unitprice) - discounted;
		const qty = this.safeNum(item.quantity ?? item.ordered);
		const total = qty * discountprice;

		return total;
	}

	exportPdf() {
		if (!this.orderResults?.length) { return; }

		const now = new Date();
		const filename = 'ORDER_INQUIRY_' + now.toISOString().slice(0, 10);
		const html = this.buildPdfHtml(this.orderResults);
		const encoded = this.globalSearchService.base64encode(html);

		const data = {
			content: encoded,
			filename: filename,
			title: 'Order Inquiry',
			subtitle: `Generated ${now.toLocaleString()}`,
			landscape: true
		};

		this.printService.pdf(data).subscribe((result: any) => {
			this.globalSearchService.downloadPdf(result.content, filename);
		});
	}

	private buildPdfHtml(orders: any[]): string {
		const showDiscounts = !!this.config?.discounts;

		// ── Helpers ──────────────────────────────────────────────────────────
		const esc = (v: any) => {
			const s = v == null ? '' : String(v);
			return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
		};

		const fmt$ = (v: any) => {
			const n = this.safeNum(v);
			const abs = Math.abs(n).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
			return (n < 0 ? '-$' : '$') + abs;
		};

		const fmtDate = (v: any) => {
			const d = this.safeDate(v);
			if (!d) { return 'N/A'; }
			try { return new Date(d).toLocaleDateString(); } catch { return String(d); }
		};

		// Header bar color varies by type / status
		const headerBg = (o: any): string => {
			if (o.type === 'credit') { return '#7a3b0e'; }
			const cls = this.statusClass(o.orderstatusid);
			if (cls === 'status-cancelled')           { return '#7d1c1c'; }
			if (cls === 'status-credit-hold')         { return '#7a4e00'; }
			if (cls === 'status-preauth-decline')     { return '#8a0044'; }
			if (cls === 'status-preauth-authorized')  { return '#1a5c3a'; }
			if (cls === 'status-invoiced')            { return '#1a4a2e'; }
			return '#1a3a5c';
		};

		const badgeCss = (o: any): string => {
			if (o.type === 'credit') { return 'background:#f4a460;color:#3d1a00;'; }
			const cls = this.statusClass(o.orderstatusid);
			const map: Record<string, string> = {
				'status-open':               'background:#d0e8ff;color:#084c8c;',
				'status-invoiced':           'background:#d0f0dc;color:#0b5d1e;',
				'status-cancelled':          'background:#fde8e8;color:#8a1c1c;',
				'status-credit-hold':        'background:#fff3e0;color:#b34a00;',
				'status-preauth-authorized': 'background:#76ffa1;color:#0d0d0d;',
				'status-preauth-decline':    'background:#ff006c;color:#fff;',
			};
			return map[cls] ?? 'background:#e9ecef;color:#495057;';
		};

		// Reusable inline-style snippets — use !important to beat the global body 12px rule
		const S = {
			td:   'border:1pt solid #ddd;padding:2pt 4pt;font-size:8pt!important;vertical-align:top;',
			tdr:  'border:1pt solid #ddd;padding:2pt 4pt;font-size:8pt!important;vertical-align:top;text-align:right;white-space:nowrap;',
			th:   'background:#eef0f3;border:1pt solid #ccc;padding:2pt 5pt;font-size:8pt!important;text-align:left;white-space:nowrap;font-weight:bold;',
			thr:  'background:#eef0f3;border:1pt solid #ccc;padding:2pt 5pt;font-size:8pt!important;text-align:right;white-space:nowrap;font-weight:bold;',
			mono: 'border:1pt solid #ddd;padding:2pt 4pt;font-size:7.5pt!important;font-family:Courier,monospace;vertical-align:top;white-space:nowrap;',
			meta: 'padding:3pt 6pt;font-size:8pt!important;background:#f5f6f8;vertical-align:top;border-right:1pt solid #ddd;border-bottom:1pt solid #e0e4ea;',
		};

		let grandTotal   = 0;
		let grandOrders  = 0;
		let grandCredits = 0;

		let html = `<style>
.ob{margin-bottom:12pt;border:1pt solid #c8cdd4;page-break-inside:avoid;}
</style>
`;

		for (const o of orders) {
			const isCredit   = o.type === 'credit';
			const creditMult = isCredit ? -1 : 1;
			const ordLabel   = isCredit ? 'Credited' : 'Ordered';
			const label      = isCredit ? 'Credit #' : 'Order #';
			const details    = o.details || [];
			const bg         = headerBg(o);
			const dispatch   = o.dispatch;

			const driverText = dispatch?.driveruserid
				? esc(dispatch.driveruserid) + (this.safeDate(dispatch?.datecreated) ? '&nbsp;·&nbsp;' + fmtDate(dispatch.datecreated) : '')
				: 'N/A';
			const delivText = this.safeDate(dispatch?.delivery_date) ? fmtDate(dispatch.delivery_date) : 'N/A';

			const tax      = this.getValueByType(o.payment_details, 'tax') * creditMult;
			const subtotal = (this.getValueByType(o.payment_details, 'subtotal') || this.getValueByType(o.payment_details, 'sub_total')) * creditMult;
			const total    = this.getValueByType(o.payment_details, 'total') * creditMult;

			grandTotal += total;
			isCredit ? grandCredits++ : grandOrders++;

			html += `<div class="ob">`;

			// ── Header bar ────────────────────────────────────────────────────
			html +=
				`<table style="width:100%;border-collapse:collapse;background:${bg};">` +
				`<tr>` +
				`<td style="padding:5pt 8pt;color:#fff;vertical-align:middle;">` +
				`<span style="font-size:8pt!important;opacity:.8;">${esc(label)}&nbsp;</span>` +
				`<span style="font-size:13pt!important;font-weight:bold;">${esc(o.orderno)}</span>` +
				`<span style="${badgeCss(o)};padding:1pt 6pt;margin-left:8pt;font-size:8pt!important;font-weight:bold;">` +
				`${esc(o.statusname)}</span>` +
				(details.length ? `<span style="font-size:7.5pt!important;opacity:.65;margin-left:10pt;">${details.length}&nbsp;line${details.length !== 1 ? 's' : ''}</span>` : '') +
				`</td>` +
				`<td style="padding:5pt 8pt;color:#fff;text-align:right;vertical-align:middle;white-space:nowrap;font-size:8pt!important;">` +
				`<strong>${esc(o.debtorno)}.${esc(o.branchcode)}</strong>` +
				(o.customerref ? `<br><span style="opacity:.75;font-size:7.5pt!important;">PO:&nbsp;${esc(o.customerref)}</span>` : '') +
				`</td>` +
				`</tr></table>`;

			// ── Meta row ─────────────────────────────────────────────────────
			const MC = (label2: string, value: string, width: string, last = false) =>
				`<td style="${S.meta}width:${width};${last ? 'border-right:none;' : ''}">` +
				`<span style="display:block;color:#888;font-size:7pt!important;margin-bottom:1pt;">${label2}</span>` +
				`<strong style="font-size:8pt!important;">${value}</strong></td>`;

			html +=
				`<table style="width:100%;border-collapse:collapse;">` +
				`<tr>` +
				MC('Created',    esc(fmtDate(o.date_created)), '12%') +
				MC('Updated',    esc(fmtDate(o.date_updated)), '12%') +
				MC('Customer',   `${esc(o.debtorno)}.${esc(o.branchcode)}`, '12%') +
				MC('PO / Ref',   esc(o.customerref || '—'), '13%') +
				MC('Deliver To', esc(o.deliverto    || '—'), '16%') +
				MC('Dispatch',   driverText,                  '16%') +
				MC('Delivered',  esc(delivText),              '10%') +
				MC('Entered By', esc(o.enteredby    || '—'), '10%', true) +
				`</tr></table>`;

			// ── Items table ───────────────────────────────────────────────────
			html +=
				`<table style="width:100%;border-collapse:collapse;"><thead><tr>` +
				`<th style="${S.th}">Item</th>` +
				`<th style="${S.th}">Description</th>` +
				`<th style="${S.thr}">QOH</th>` +
				`<th style="${S.thr}">${esc(ordLabel)}</th>` +
				`<th style="${S.thr}">Invoiced</th>` +
				`<th style="${S.thr}">Outstanding</th>` +
				`<th style="${S.thr}">Price</th>`;
			if (showDiscounts) { html += `<th style="${S.thr}">Disc&nbsp;%</th>`; }
			html += `<th style="${S.thr}">Total</th></tr></thead><tbody>`;

			details.forEach((det: any, idx: number) => {
				const qty         = this.safeNum(det.quantity ?? det.ordered);
				const invoiced    = this.safeNum(det.qtyinvoiced);
				const outstanding = qty - invoiced;
				const lineTotal   = this.safeNum(this.getDiscountTotal(det)) * creditMult;
				const rowBg       = idx % 2 === 0 ? '#ffffff' : '#f4f7fb';
				const outTd       = outstanding > 0
					? `${S.tdr}font-weight:bold;color:#b84200;`
					: S.tdr;

				html +=
					`<tr style="background:${rowBg};">` +
					`<td style="${S.mono}">${esc(det.stkcode)}</td>` +
					`<td style="${S.td}">${esc(det.itemdesc)}</td>` +
					`<td style="${S.tdr}">${this.safeNum(det.qoh ?? det.QOH)}</td>` +
					`<td style="${S.tdr}">${qty}</td>` +
					`<td style="${S.tdr}">${invoiced}</td>` +
					`<td style="${outTd}">${outstanding}</td>` +
					`<td style="${S.tdr}">${fmt$(det.unitprice)}</td>`;
				if (showDiscounts) {
					html += `<td style="${S.tdr}">${this.safeNum(det.discountpercent).toFixed(1)}%</td>`;
				}
				html += `<td style="${S.tdr}">${fmt$(lineTotal)}</td></tr>`;
			});

			if (!details.length) {
				const colspan = showDiscounts ? 9 : 8;
				html += `<tr><td colspan="${colspan}" style="${S.td}color:#aaa;text-align:center;">No line items</td></tr>`;
			}

			html += `</tbody></table>`;

			// ── Totals footer ─────────────────────────────────────────────────
			html +=
				`<table style="width:100%;border-collapse:collapse;background:#f0f3f7;border-top:2pt solid #c0c8d4;">` +
				`<tr>` +
				`<td style="padding:3pt 7pt;font-size:7.5pt!important;color:#777;">` +
				`${esc(o.enteredby || '')}${o.takenby && o.takenby !== o.enteredby ? ' / edited: ' + esc(o.takenby) : ''}</td>` +
				`<td style="padding:3pt 7pt;font-size:8pt!important;font-weight:bold;text-align:right;white-space:nowrap;">` +
				`Tax:&nbsp;${fmt$(tax)}</td>` +
				`<td style="padding:3pt 7pt;font-size:8pt!important;font-weight:bold;text-align:right;white-space:nowrap;">` +
				`Subtotal:&nbsp;${fmt$(subtotal)}</td>` +
				`<td style="padding:3pt 7pt;font-size:10pt!important;font-weight:bold;text-align:right;white-space:nowrap;color:${bg};">` +
				`Total:&nbsp;${fmt$(total)}</td>` +
				`</tr></table>`;

			html += `</div>`;
		}

		// ── Grand summary (only when multiple orders) ─────────────────────────
		if (orders.length > 1) {
			html +=
				`<table style="width:100%;border-collapse:collapse;margin-top:16pt;border:2pt solid #1a3a5c;">` +
				`<tr style="background:#1a3a5c;">` +
				`<th colspan="4" style="padding:5pt 8pt;color:#fff;font-size:10pt!important;font-weight:bold;text-align:center;">` +
				`Export Summary</th></tr>` +
				`<tr style="background:#f0f3f7;">` +
				`<td style="padding:5pt 10pt;font-size:9pt!important;text-align:center;border:1pt solid #c0c8d4;">` +
				`Total Orders<br><strong style="font-size:11pt!important;">${grandOrders}</strong></td>` +
				`<td style="padding:5pt 10pt;font-size:9pt!important;text-align:center;border:1pt solid #c0c8d4;">` +
				`Credits<br><strong style="font-size:11pt!important;">${grandCredits}</strong></td>` +
				`<td style="padding:5pt 10pt;font-size:9pt!important;text-align:center;border:1pt solid #c0c8d4;">` +
				`Records<br><strong style="font-size:11pt!important;">${orders.length}</strong></td>` +
				`<td style="padding:5pt 10pt;font-size:9pt!important;text-align:center;border:1pt solid #c0c8d4;color:#1a3a5c;">` +
				`Net Grand Total<br><strong style="font-size:13pt!important;">${fmt$(grandTotal)}</strong></td>` +
				`</tr></table>`;
		}

		return html;
	}

	private exportXls(): void {
		const now = new Date();
		const filename = 'ORDER_INQUIRY_' + now.toISOString().slice(0, 10);
		const container = this.resultTable.nativeElement as HTMLElement;

		// Each order card → create flattened rows with header + item data
		const cards = container.querySelectorAll('.order-card') as NodeListOf < HTMLElement > ;
		const wrapper = document.createElement('div');

		// Create a single flattened table for all orders and items
		const flattenedTable = document.createElement('table');
		flattenedTable.style.borderCollapse = 'collapse';
		flattenedTable.style.width = '100%';
		flattenedTable.style.fontFamily = 'Arial, Helvetica, sans-serif';
		flattenedTable.style.fontSize = '11px';

		// Create header row with all columns
		const headerRow = document.createElement('tr');
		const headerColumns = [
			'Order #', 'Status', 'Created', 'Updated', 'Customer', 'PO / Ref', 'Deliver To', 'Dispatch',
			'Delivered', 'Entered By', 'Edited By', 'Item', 'Description', 'QOH', 'Ordered', 'Invoiced',
			'Outstanding', 'Price'
		];

		// Add discount column only if config.discounts is enabled
		if (this.config?.discounts) {
			headerColumns.push('Discount');
		}

		headerColumns.forEach(column => {
			const th = document.createElement('th');
			th.textContent = column;
			th.style.border = '1px solid #d0d7de';
			th.style.padding = '8px';
			th.style.textAlign = 'left';
			th.style.background = '#eef2f7';
			th.style.fontWeight = '600';
			th.style.whiteSpace = 'nowrap';
			th.style.fontSize = '11px';
			headerRow.appendChild(th);
		});
		flattenedTable.appendChild(headerRow);

		cards.forEach((card) => {
			// 1) Collect header fields
			const $ = < T extends Element = HTMLElement > (sel: string, root: Element | Document = card) =>
				(root.querySelector(sel) as T | null);

			const text = (el: Element | null) => (el && (el as HTMLElement).textContent?.trim()) || '—';
			const valFromMeta = (labelStartsWith: string) => {
				const meta = $('.order-header-meta');
				if (!meta) {return '—';}
				const divs = meta.querySelectorAll('div') as NodeListOf < HTMLElement > ;
				for (const d of Array.from(divs)) {
					const label = d.querySelector('span')?.textContent?.trim() || '';
					if (label.toLowerCase().startsWith(labelStartsWith.toLowerCase())) {
						return d.querySelector('strong')?.textContent?.trim() || '—';
					}
				}
				return '—';
			};

			// Extract header information
			const orderNo = text($('.order-header-main .order-number'));
			const status = text($('.order-header-main .status-badge'));
			const created = valFromMeta('created');
			const updated = valFromMeta('updated');
			const customer = valFromMeta('customer');
			const poRef = valFromMeta('po');
			const deliver = valFromMeta('deliver to');
			const dispatch = valFromMeta('dispatch');
			const delivered = valFromMeta('delivered');
			const entered = valFromMeta('entered by');
			const edited = valFromMeta('edited by');

			// 2) Get items table and create rows for each item
			const itemsTable = card.querySelector('table') as HTMLTableElement | null;
			if (!itemsTable) {
				// If no items, create a single row with header info only
				const emptyItemData = ['—', '—', '—', '—', '—', '—', '—', '—'];
				if (this.config?.discounts) {
					emptyItemData.push('—');
				}
				const emptyRow = this.createFlattenedRow(
					[orderNo, status, created, updated, customer, poRef, deliver, dispatch, delivered, entered, edited],
					emptyItemData
				);
				flattenedTable.appendChild(emptyRow);
				return;
			}

			// 3) Process each item row
			const itemRows = itemsTable.querySelectorAll('tbody tr');
			itemRows.forEach((itemRow) => {
				const cells = itemRow.querySelectorAll('td');
				// Remove the last column (Total) from the item data
				const allItemData = Array.from(cells).map(cell => cell.textContent?.trim() || '—');
				const itemData = allItemData.slice(0, -1); // Remove the last column (Total)

				// Create flattened row with header + item data
				const flattenedRow = this.createFlattenedRow(
					[orderNo, status, created, updated, customer, poRef, deliver, dispatch, delivered, entered, edited],
					itemData
				);
				flattenedTable.appendChild(flattenedRow);
			});

			// 4) No totals row needed - just header and items
		});

		wrapper.appendChild(flattenedTable);

		// Encode and send
		const html = wrapper.innerHTML;
		const encoded = this.globalSearchService.base64encode(html);
		const data = {
			content: encoded,
			filename: filename,
			title: 'Order Inquiry Export',
			subtitle: `Created @ ${now.toLocaleString()}`
		};

		this.printService.xls(data).subscribe((result: any) => {
			this.globalSearchService.downloadXls(result.content, filename);
		});
	}

	// Helper method to create a flattened row with header + item data
	private createFlattenedRow(headerData: string[], itemData: string[]): HTMLTableRowElement {
		const row = document.createElement('tr');

		// Combine header and item data
		const allData = [...headerData, ...itemData];

		allData.forEach((value, index) => {
			const cell = document.createElement('td');
			cell.textContent = value;
			cell.style.border = '1px solid #e5e7eb';
			cell.style.padding = '8px';
			cell.style.verticalAlign = 'top';
			cell.style.fontSize = '11px';

			// Apply appropriate formatting based on data type
			if (index < headerData.length) {
				// Header columns
				if (index === 0) {cell.setAttribute('data-type', 'order_number');} // Order #
				else if (index === 1) {cell.setAttribute('data-type', 'status');} // Status
				else if (index === 2 || index === 3 || index === 8) {cell.setAttribute('data-type', 'date');} // Dates
				else if (index === 4) {cell.setAttribute('data-type', 'customer');} // Customer
				else if (index === 5) {cell.setAttribute('data-type', 'po_reference');} // PO Ref
				else if (index === 6) {cell.setAttribute('data-type', 'delivery_address');} // Deliver To
				else if (index === 7) {cell.setAttribute('data-type', 'dispatch_info');} // Dispatch
				else {cell.setAttribute('data-type', 'user');} // Users
			} else {
				// Item columns
				const itemIndex = index - headerData.length;
				if (itemIndex === 0) {
					cell.setAttribute('data-type', 'item_code');
					cell.style.fontFamily = 'Consolas, "Liberation Mono", Menlo, Monaco, monospace';
					cell.style.whiteSpace = 'nowrap';
				} else if (itemIndex === 1) {
					cell.setAttribute('data-type', 'description');
				} else if (itemIndex >= 2 && itemIndex <= 5) {
					cell.setAttribute('data-type', 'quantity');
					cell.style.textAlign = 'right';
					cell.style.fontVariantNumeric = 'tabular-nums';
				} else if (itemIndex === 6) {
					cell.setAttribute('data-type', 'currency');
					cell.style.textAlign = 'right';
					cell.style.fontVariantNumeric = 'tabular-nums';
				} else if (itemIndex === 7) {
					cell.setAttribute('data-type', 'percentage');
					cell.style.textAlign = 'right';
					cell.style.fontVariantNumeric = 'tabular-nums';
				}
			}

			row.appendChild(cell);
		});

		return row;
	}

	statusClass(id: any): string {
		const n = parseInt(id, 10);
		if (n === 80) { return 'status-credit-hold'; }
		if (n === 53) { return 'status-preauth-authorized'; }
		if (n === 52) { return 'status-preauth-decline'; }
		if (n >= 90) {return 'status-cancelled';}
		if (n > 29 && n < 51) {return 'status-invoiced';}
		if (n <= 29) {return 'status-open';}
		return 'status-default';
	}

	financial(num: number): number {

		const rounded = Math.round((num + Number.EPSILON) * 100) / 100; // Rounding to 2 decimal places again
		return parseFloat(rounded.toFixed(2));
	}

	navTo(link) {

		this.router.navigate([link]);
	}
	back(): void {
		this.location.back()
	}

}